import * as React from 'react';
import { History } from 'history';
import { Menu, Grid } from '@mui/material';
import { Button, SwipeDrawer } from '.';
import AppService from '../services/app.service';

interface Props {
  history?: History;
  id?: string;
  anchorEl: HTMLElement | null,  
  action?: {
    caption: string, 
    icon?: string,
    color?: any,
    url?: string,
    state?: any,
    readOnly?: boolean,
  }[];
  onClose: () => void;
}

export const ActionButton: React.FunctionComponent<Props> = (props) => {
  const isMobile = AppService.isMobile();
  const historyState: any = props.history?.location.state;
  const [anchorEl, setAnchorEl] = React.useState(props.anchorEl);
  
  const onClose = () => {    
    setAnchorEl(null);
    props.onClose();
  }

  const onClick = (action: any) => {
    props.history?.push(action.url, {...historyState, ...action.state});
  }

  const actions = () => {
    return (
      <Grid container direction='column' alignItems='flex-start'>
      {props.action?.map((d, i) => {
        if (d.url)
        return (
          <Button key={i} label={d.caption} color={d.color} startIcon={d.icon} fullWidth sx={{textAlign: 'left', mb: 1}} onClick={() => onClick(d)} />
        )
      })}
      </Grid>
    );
  }
    
  React.useEffect(() => {
    setAnchorEl(props.anchorEl)
  }, [props.anchorEl])

  return (
    <>
    {isMobile?
      <SwipeDrawer type='bottom' open={!!anchorEl} onClose={onClose}>
        {actions()}   
      </SwipeDrawer>
      
    : //Web view
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onClose}>
        {actions()}
      </Menu>
    }  
    </>
  )
}



